<template>
  <router-link class="d-flex" :to="{ name: 'learning-unit' }" rel="noopener noreferrer">
    <img src="@/assets/4life-logo.svg" class="d-inline-block my-auto mr-3" :height="size" />
  </router-link>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '40px'
    }
  }
};
</script>
